export default __webpack_public_path__ + "static/protectia-climei-0d724b291d4b2e5664a2400c28bcfd81.jpg";